import { render } from "./InclusionDetailModal.vue?vue&type=template&id=7617f5bf&scoped=true&ts=true&lang=pug"
import script from "./InclusionDetailModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InclusionDetailModal.vue?vue&type=script&lang=ts&setup=true"

import "./InclusionDetailModal.vue?vue&type=style&index=0&id=7617f5bf&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7617f5bf"]])

export default __exports__